export default "__VITE_ASSET__Ip8xei48__"